import { STATUS_CODE } from '@constants/application';

export const FUNDING_STATUS = {
  [STATUS_CODE.PENDING_USER_SIGN_AGREEMENT]: 'Pending Sign Agreement',
  [STATUS_CODE.PENDING_FUND_DISBURSEMENT]: 'Pending Disbursement',
  [STATUS_CODE.FUND_DISBURSED]: 'Fund Disbursed',
};
